import { render } from "./IconUndo.vue?vue&type=template&id=46fa3397"
import script from "./IconUndo.vue?vue&type=script&lang=js"
export * from "./IconUndo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__